import { SignedInRailView } from "@softmax/product-ux/shell";
import type { PropsWithChildren, ReactNode } from "react";

import { siteShape } from "@softmax/web-features/site/records";

export function SignedInRail({
  session,
  sidebar,
  children,
}: PropsWithChildren<{ session: boolean; sidebar: ReactNode }>) {
  return (
    <SignedInRailView
      enabled={session && siteShape.signedInRail}
      sidebar={sidebar}
    >
      {children}
    </SignedInRailView>
  );
}
